export function groupByType(items) {
  return items.reduce((acc, item) => {
    const type = item.type || "other"
    acc[type] = acc[type] || []
    acc[type].push(item)
    return acc
  }, {})
}

export function flattenGrouped(grouped) {
  const items = []
  Object.values(grouped).forEach((group) => {
    group.forEach((item) => items.push(item))
  })
  return items
}

export function globalItemIndex(groupedResults, groupIndex, itemIndex) {
  let index = 0
  const entries = Object.entries(groupedResults)
  for (let i = 0; i < groupIndex; i++) {
    index += entries[i][1].length
  }
  return index + itemIndex
}
